import { isValidDataFlags, dataFlagsToText, DATA_ERROR_VALUE, isEmpty, measUnitsConversion, userMetricUnits } from './enums';

// Enums
export const ALARM_CATEGORY = {
	SYSTEM_CRITICAL:	1,
	TEMP:				2,
	TEMP_DIFF:			3,
	UNIT_VOLT_MAINT:	4,
	UNIT_VOLT_CRIT:		5,
	UNIT_IMPED_MAINT:	6,
	UNIT_IMPED_CRIT:	7,
	DISCHARGE:			8,
	AUX:				9,
	ABORT:				10,
	EQUIPMENT:			11,
	POLLING:			12,
}

export const CATEGORY_COLORS = {
	1:	'#f94144',
	2:	'#f3722c',
	3:	'#f8961e',
	4:	'#f9844a',
	5:	'#f9844a',
	6:	'#f9c74f',
	7:	'#f9c74f',
	8:	'#90be6d',
	9:	'#43aa8b',
	10:	'#4d908e',
	11:	'#577590',
	12:	'#277da1',
}

export const ALARM_TYPE = {
	Alarm_ACPowerFail_Type: 1,
	Alarm_PwrOutage_Type: 2,

	Alarm_BatteryVoltage_Type: 3,
	Alarm_StringVoltage_Type: 19,
	Alarm_StringBreakerOpen_Type: 48,
	
	Alarm_UnitVoltage_Type: 4,
	Alarm_AvgImpedance_Type: 5,
	Alarm_InitImpedance_Type: 6,
	Alarm_Interconnect_Impedance_Type: 62,

	Alarm_Temperature_Type: 7,
	Alarm_TemperatureVM24T_Type: 44,

	Alarm_DiffTemperature_Type: 8,
	Alarm_TemperatureVM24TDifferential_Type: 45,

	Alarm_Aux1_Type: 14,
	Alarm_LVIRA_Aux1_Type: 20,
	Alarm_LVIRA_Aux2_Type: 21,
	Alarm_LVIRA_Aux3_Type: 22,
	Alarm_LVIRA_Aux4_Type: 23,
	Alarm_LVIRA_Aux5: 56,
	Alarm_LVIRA_Aux6: 57,
	Alarm_LVIRA_Aux7: 58,
	Alarm_LVIRA_Aux8: 59,

	Alarm_Nicad_Type: 9,
	Alarm_Unlearned_Type: 10,
	Alarm_WasUnlearned_Type: 11,
	Alarm_GroundFault_Type: 12,
	Alarm_FuseOut_Type: 13,
	Alarm_MemBattery_Type: 15,
	Alarm_WrongNbrUnits_Type: 16,
	Alarm_WrongCntrLead_Type: 17,
	Alarm_NoImpMsr_Type: 18,
	Alarm_WrongNbrVoltModules_Type: 24,
	Alarm_WrongNbrCurrentModules_Type: 25,
	Alarm_CommErrorVoltModule_Type: 26,
	Alarm_CommErrorCurrentModule_Type: 27,
	Alarm_UnknownModuleType_Type: 28,
	Alarm_CorruptConfig_Type: 29,
	Alarm_HardwareFailure_Type: 30,
	Alarm_BackupBattery_Type: 31,
	Alarm_ModuleInitFailure_Type: 32,
	Alarm_ModemFailure_Type: 38,
	Alarm_ModemLineFailure_Type: 39,
	Alarm_InvalidCommConfig_Type: 40,
	Alarm_NetworkMissing_Type: 41,
	Alarm_WrongNbrVoltagesVM24T_Type: 42,
	Alarm_WrongNbrTempsVM24T_Type: 43,
	Alarm_ModuleRelearnConnectionFailure_Type: 46,
	Alarm_LControllerHardwareFailure_Type: 50,
	Alarm_LControllerConfigurationAlarm_Type: 51,
	Alarm_Wrong_Nbr_TSV_Modules: 54,
	Alarm_Controller_Lost_External_Power: 55,
	Alarm_CellQ_Modbus_Master_Comm_Error: 60,
	Alarm_CellQ_Modbus_Slave_Equipment_Error: 61,
	Alarm_NetworkPingError_Type: 90,
	Alarm_DischargeMemoryFull_Type: 500,
	Alarm_PollFailure_Type: 501,
	
	Alarm_ImpMsrmentAbortHighPosVolt_Type: 33,
	Alarm_ImpMsrmentAbortLowPosVolt_Type: 34,
	Alarm_ImpMsrmentAbortHighNegVolt_Type: 35,
	Alarm_ImpMsrmentAbortLowNegVolt_Type: 36,
	Alarm_ImpMsrmentAbortHighLoadTemp_Type: 37,
	Alarm_ImpMsrmentAbortDischarge_Type: 47,
	Alarm_ImpMsrmentAbortStringBreakerOpen_Type: 49,
	Alarm_ImpMsrmentAbortManually_Type: 52,
	Alarm_ImpMsrmentAbortMajorEquipmentAlarm_Type: 53,
}

export const POLL_STATUS = {
	STATUS_COM_PORT_NON_EXISTENT: 1,
	STATUS_COM_PORT_CANNOT_OPEN: 2,
	STATUS_UNABLE_TO_LOAD_LOC: 3,
	STATUS_UNABLE_TO_LOAD_COMM_SETTINGS: 4,
	STATUS_WRONG_COMM_PORT: 5,
	STATUS_UNABLE_TO_CHANGE_COMM_SPEED: 6,
	STATUS_COMMUNICATION_FAILURE: 7,
	STATUS_LOCATION_ID_WRONG: 8,
	STATUS_CONTROLLER_ID_WRONG: 9,
	STATUS_NBR_STRINGS_WRONG: 10,
	STATUS_NBR_UNITS_WRONG: 11,
	STATUS_BUSY_MEASURING_IMP: 12,
	STATUS_BUSY_IN_DISCHARGE: 13,
	STATUS_ERROR_RETRIEVING_DISCHARGE_DATA: 14,
	STATUS_NO_RESPONSE_FROM_MODEM: 15,
	STATUS_NUMBER_BUSY: 16,
	STATUS_MODEM_ERROR: 17,
	STATUS_NO_DIALTONE: 18,
	STATUS_DIAL_TIMEOUT: 19,
	STATUS_ERROR_RETRIEVING_MSR_DATA: 20,
	STATUS_NEEDS_PHONE_NUMBER: 21,
	STATUS_NEEDS_NO_PHONE_NUMBER: 22,
	STATUS_NETWORK_CONNECTION_TIMEOUT: 24,
	STATUS_NO_ANSWER: 25,
	STATUS_NO_CARRIER: 26,
	STATUS_DELAY_RETRIEVING_DISCHARGE_DATA: 27,
	STATUS_DELAY_RETRIEVING_MSR_DATA: 28,
	STATUS_MODEL_NBR_WRONG: 29,
	STATUS_NBR_TEMPS_WRONG: 30,
	STATUS_SERIAL_NBR_WRONG: 31,
	STATUS_LOCATION_ID_DOESNT_EXIST: 32,
	STATUS_MODEL_NOT_PERMITTED: 33,
	STATUS_SUCCESS_POLL: 40,
	STATUS_SUCCESS_DISCHARGE_ALARM: 41,
	STATUS_SUCCESS_RCVD_ALARM: 42,
}

const ALARM_TEMP_CODE = {
	AMBIENT: 1,
	UNIT: 100
}

const ALARM_SEVERITY_CODE = {
	CRITICAL: 0,
	MAINTENANCE: 1,
}

// Functions
export function EventTypeToFilterNum(eventType, eventNumber) {
	if ( 
		eventType === ALARM_TYPE.Alarm_BatteryVoltage_Type ||
		eventType === ALARM_TYPE.Alarm_StringVoltage_Type ||
		eventType === ALARM_TYPE.Alarm_StringBreakerOpen_Type
	) {
	
		return ALARM_CATEGORY.SYSTEM_CRITICAL;
	
	} else if (
		eventType === ALARM_TYPE.Alarm_Temperature_Type ||
		eventType === ALARM_TYPE.Alarm_TemperatureVM24T_Type
	) {

		return ALARM_CATEGORY.TEMP;

	} else if (
		eventType === ALARM_TYPE.Alarm_DiffTemperature_Type ||
		eventType === ALARM_TYPE.Alarm_TemperatureVM24TDifferential_Type
	) {

		return ALARM_CATEGORY.TEMP_DIFF;

	} else if ( eventType === ALARM_TYPE.Alarm_UnitVoltage_Type && eventNumber === ALARM_SEVERITY_CODE.MAINTENANCE ) {

		return ALARM_CATEGORY.UNIT_VOLT_MAINT;

	} else if ( eventType === ALARM_TYPE.Alarm_UnitVoltage_Type && eventNumber === ALARM_SEVERITY_CODE.CRITICAL ) {

		return ALARM_CATEGORY.UNIT_VOLT_CRIT;

	} else if ( eventNumber === ALARM_SEVERITY_CODE.MAINTENANCE && (
		eventType === ALARM_TYPE.Alarm_AvgImpedance_Type ||
		eventType === ALARM_TYPE.Alarm_InitImpedance_Type ||
		eventType === ALARM_TYPE.Alarm_Interconnect_Impedance_Type
	)) {

		return ALARM_CATEGORY.UNIT_IMPED_MAINT;

	} else if ( eventNumber === ALARM_SEVERITY_CODE.CRITICAL && (
		eventType === ALARM_TYPE.Alarm_AvgImpedance_Type ||
		eventType === ALARM_TYPE.Alarm_InitImpedance_Type ||
		eventType === ALARM_TYPE.Alarm_Interconnect_Impedance_Type
	)) {

		return ALARM_CATEGORY.UNIT_IMPED_CRIT;

	} else if (
		eventType === ALARM_TYPE.Alarm_ACPowerFail_Type ||
		eventType === ALARM_TYPE.Alarm_PwrOutage_Type
	) {

		return ALARM_CATEGORY.DISCHARGE;

	} else if (
		eventType === ALARM_TYPE.Alarm_Aux1_Type ||
		eventType === ALARM_TYPE.Alarm_LVIRA_Aux1_Type ||
		eventType === ALARM_TYPE.Alarm_LVIRA_Aux2_Type ||
		eventType === ALARM_TYPE.Alarm_LVIRA_Aux3_Type ||
		eventType === ALARM_TYPE.Alarm_LVIRA_Aux4_Type ||
		eventType === ALARM_TYPE.Alarm_LVIRA_Aux5 ||
		eventType === ALARM_TYPE.Alarm_LVIRA_Aux6 ||
		eventType === ALARM_TYPE.Alarm_LVIRA_Aux7 ||
		eventType === ALARM_TYPE.Alarm_LVIRA_Aux8
	) {

		return ALARM_CATEGORY.AUX;

	} else if (
		eventType === ALARM_TYPE.Alarm_ImpMsrmentAbortHighPosVolt_Type ||
		eventType === ALARM_TYPE.Alarm_ImpMsrmentAbortLowPosVolt_Type ||
		eventType === ALARM_TYPE.Alarm_ImpMsrmentAbortHighNegVolt_Type ||
		eventType === ALARM_TYPE.Alarm_ImpMsrmentAbortLowNegVolt_Type ||
		eventType === ALARM_TYPE.Alarm_ImpMsrmentAbortHighLoadTemp_Type ||
		eventType === ALARM_TYPE.Alarm_ImpMsrmentAbortDischarge_Type ||
		eventType === ALARM_TYPE.Alarm_ImpMsrmentAbortStringBreakerOpen_Type ||
		eventType === ALARM_TYPE.Alarm_ImpMsrmentAbortManually_Type ||
		eventType === ALARM_TYPE.Alarm_ImpMsrmentAbortMajorEquipmentAlarm_Type
	) {

		return ALARM_CATEGORY.ABORT;

	} else if ( eventType === ALARM_TYPE.Alarm_PollFailure_Type ) {

		return ALARM_CATEGORY.POLLING;

	} else if (
		eventType === ALARM_TYPE.Alarm_Nicad_Type ||
		eventType === ALARM_TYPE.Alarm_Unlearned_Type ||
		eventType === ALARM_TYPE.Alarm_WasUnlearned_Type ||
		eventType === ALARM_TYPE.Alarm_GroundFault_Type ||
		eventType === ALARM_TYPE.Alarm_FuseOut_Type ||
		eventType === ALARM_TYPE.Alarm_MemBattery_Type ||
		eventType === ALARM_TYPE.Alarm_WrongNbrUnits_Type ||
		eventType === ALARM_TYPE.Alarm_WrongCntrLead_Type ||
		eventType === ALARM_TYPE.Alarm_NoImpMsr_Type ||
		eventType === ALARM_TYPE.Alarm_WrongNbrVoltModules_Type ||
		eventType === ALARM_TYPE.Alarm_WrongNbrCurrentModules_Type ||
		eventType === ALARM_TYPE.Alarm_CommErrorVoltModule_Type ||
		eventType === ALARM_TYPE.Alarm_CommErrorCurrentModule_Type ||
		eventType === ALARM_TYPE.Alarm_UnknownModuleType_Type ||
		eventType === ALARM_TYPE.Alarm_CorruptConfig_Type ||
		eventType === ALARM_TYPE.Alarm_HardwareFailure_Type ||
		eventType === ALARM_TYPE.Alarm_BackupBattery_Type ||
		eventType === ALARM_TYPE.Alarm_ModuleInitFailure_Type ||
		eventType === ALARM_TYPE.Alarm_ModemFailure_Type ||
		eventType === ALARM_TYPE.Alarm_ModemLineFailure_Type ||
		eventType === ALARM_TYPE.Alarm_InvalidCommConfig_Type ||
		eventType === ALARM_TYPE.Alarm_NetworkMissing_Type ||
		eventType === ALARM_TYPE.Alarm_WrongNbrVoltagesVM24T_Type ||
		eventType === ALARM_TYPE.Alarm_WrongNbrTempsVM24T_Type ||
		eventType === ALARM_TYPE.Alarm_ModuleRelearnConnectionFailure_Type ||
		eventType === ALARM_TYPE.Alarm_LControllerHardwareFailure_Type ||
		eventType === ALARM_TYPE.Alarm_LControllerConfigurationAlarm_Type ||
		eventType === ALARM_TYPE.Alarm_Wrong_Nbr_TSV_Modules ||
		eventType === ALARM_TYPE.Alarm_Controller_Lost_External_Power ||
		eventType === ALARM_TYPE.Alarm_CellQ_Modbus_Master_Comm_Error ||
		eventType === ALARM_TYPE.Alarm_CellQ_Modbus_Slave_Equipment_Error ||
		eventType === ALARM_TYPE.Alarm_NetworkPingError_Type ||
		eventType === ALARM_TYPE.Alarm_DischargeMemoryFull_Type
	) {

		return ALARM_CATEGORY.EQUIPMENT;

	}
}


export function FilterNumToEventTypes(filterNum) {
	if ( filterNum === ALARM_CATEGORY.SYSTEM_CRITICAL ) {

		return [
			ALARM_TYPE.Alarm_BatteryVoltage_Type,
			ALARM_TYPE.Alarm_StringVoltage_Type,
			ALARM_TYPE.Alarm_StringBreakerOpen_Type
		];
	
	} else if ( filterNum === ALARM_CATEGORY.TEMP ) {

		return [
			ALARM_TYPE.Alarm_Temperature_Type,
			ALARM_TYPE.Alarm_TemperatureVM24T_Type,
		];

	} else if ( filterNum === ALARM_CATEGORY.TEMP_DIFF ) {
		
		return [
			ALARM_TYPE.Alarm_DiffTemperature_Type,
			ALARM_TYPE.Alarm_TemperatureVM24TDifferential_Type,
		];


	} else if ( filterNum === ALARM_CATEGORY.UNIT_VOLT_CRIT || 
				filterNum === ALARM_CATEGORY.UNIT_VOLT_MAINT ) {
		
		return [
			ALARM_TYPE.Alarm_UnitVoltage_Type
		];

	} else if ( filterNum === ALARM_CATEGORY.UNIT_IMPED_CRIT ||
				filterNum === ALARM_CATEGORY.UNIT_IMPED_MAINT ) {
		
		return [
			ALARM_TYPE.Alarm_AvgImpedance_Type,
			ALARM_TYPE.Alarm_InitImpedance_Type,
			ALARM_TYPE.Alarm_Interconnect_Impedance_Type,
		];

	} else if ( filterNum === ALARM_CATEGORY.DISCHARGE ) {
		
		return [
			ALARM_TYPE.Alarm_ACPowerFail_Type,
			ALARM_TYPE.Alarm_PwrOutage_Type,
		];

	} else if ( filterNum === ALARM_CATEGORY.AUX ) {
		
		return [
			ALARM_TYPE.Alarm_Aux1_Type,
			ALARM_TYPE.Alarm_LVIRA_Aux1_Type,
			ALARM_TYPE.Alarm_LVIRA_Aux2_Type,
			ALARM_TYPE.Alarm_LVIRA_Aux3_Type,
			ALARM_TYPE.Alarm_LVIRA_Aux4_Type,
			ALARM_TYPE.Alarm_LVIRA_Aux5,
			ALARM_TYPE.Alarm_LVIRA_Aux6,
			ALARM_TYPE.Alarm_LVIRA_Aux7,
			ALARM_TYPE.Alarm_LVIRA_Aux8
		];

	} else if ( filterNum === ALARM_CATEGORY.ABORT ) {
		
		return [
			ALARM_TYPE.Alarm_ImpMsrmentAbortHighPosVolt_Type,
			ALARM_TYPE.Alarm_ImpMsrmentAbortLowPosVolt_Type,
			ALARM_TYPE.Alarm_ImpMsrmentAbortHighNegVolt_Type,
			ALARM_TYPE.Alarm_ImpMsrmentAbortLowNegVolt_Type,
			ALARM_TYPE.Alarm_ImpMsrmentAbortHighLoadTemp_Type,
			ALARM_TYPE.Alarm_ImpMsrmentAbortDischarge_Type,
			ALARM_TYPE.Alarm_ImpMsrmentAbortStringBreakerOpen_Type,
			ALARM_TYPE.Alarm_ImpMsrmentAbortManually_Type,
			ALARM_TYPE.Alarm_ImpMsrmentAbortMajorEquipmentAlarm_Type
		];

	} else if ( filterNum === ALARM_CATEGORY.POLLING ) {

		return [ALARM_TYPE.Alarm_PollFailure_Type];

	} else if ( filterNum === ALARM_CATEGORY.EQUIPMENT ) {

		return [
			ALARM_TYPE.Alarm_Nicad_Type,
			ALARM_TYPE.Alarm_Unlearned_Type ,
			ALARM_TYPE.Alarm_WasUnlearned_Type,
			ALARM_TYPE.Alarm_GroundFault_Type,
			ALARM_TYPE.Alarm_FuseOut_Type,
			ALARM_TYPE.Alarm_MemBattery_Type,
			ALARM_TYPE.Alarm_WrongNbrUnits_Type,
			ALARM_TYPE.Alarm_WrongCntrLead_Type,
			ALARM_TYPE.Alarm_NoImpMsr_Type,
			ALARM_TYPE.Alarm_WrongNbrVoltModules_Type,
			ALARM_TYPE.Alarm_WrongNbrCurrentModules_Type,
			ALARM_TYPE.Alarm_CommErrorVoltModule_Type,
			ALARM_TYPE.Alarm_CommErrorCurrentModule_Type,
			ALARM_TYPE.Alarm_UnknownModuleType_Type,
			ALARM_TYPE.Alarm_CorruptConfig_Type,
			ALARM_TYPE.Alarm_HardwareFailure_Type,
			ALARM_TYPE.Alarm_BackupBattery_Type,
			ALARM_TYPE.Alarm_ModuleInitFailure_Type,
			ALARM_TYPE.Alarm_ModemFailure_Type,
			ALARM_TYPE.Alarm_ModemLineFailure_Type,
			ALARM_TYPE.Alarm_InvalidCommConfig_Type,
			ALARM_TYPE.Alarm_NetworkMissing_Type,
			ALARM_TYPE.Alarm_WrongNbrVoltagesVM24T_Type,
			ALARM_TYPE.Alarm_WrongNbrTempsVM24T_Type,
			ALARM_TYPE.Alarm_ModuleRelearnConnectionFailure_Type,
			ALARM_TYPE.Alarm_LControllerHardwareFailure_Type,
			ALARM_TYPE.Alarm_LControllerConfigurationAlarm_Type,
			ALARM_TYPE.Alarm_Wrong_Nbr_TSV_Modules,
			ALARM_TYPE.Alarm_Controller_Lost_External_Power,
			ALARM_TYPE.Alarm_CellQ_Modbus_Master_Comm_Error,
			ALARM_TYPE.Alarm_CellQ_Modbus_Slave_Equipment_Error,
			ALARM_TYPE.Alarm_NetworkPingError_Type,
			ALARM_TYPE.Alarm_DischargeMemoryFull_Type
		];
	}
}

export function EventTypeToColor(eventType, eventNumber) {
	const filterNum = EventTypeToFilterNum(eventType, eventNumber);
	return CATEGORY_COLORS[filterNum];
}

export function AlarmEventToStatusText(event) {
	if (!isEmpty(event)) {

		const eventType = event.alarm_type;
		const number = event.number;
		const stringNum = event.string_nbr;
		const unitNum = event.unit_nbr;
		const value = isValidDataFlags(event.value, event.get_data_flags);
		const tempUnits = userMetricUnits() ? ' °C' : ' °F';

		// Check the event type an return the appropriate status text
		switch(eventType) {
			case ALARM_TYPE.Alarm_ACPowerFail_Type:
				return 'AC Power Failure';
				
			case ALARM_TYPE.Alarm_PwrOutage_Type:
				return 'Battery Discharge Event';
				
			case ALARM_TYPE.Alarm_BatteryVoltage_Type:
				let battVoltageStatus = 'System Voltage Alarm';
				if (value === DATA_ERROR_VALUE.OUTOFRANGE_VALUE) {
					battVoltageStatus = battVoltageStatus + ': Out of Range';
				} else if (value > DATA_ERROR_VALUE.INVALID_VALUE) {
					battVoltageStatus = battVoltageStatus + ': ' + value.toFixed(1) + ' VDC';
				}
				return battVoltageStatus;
				
			case ALARM_TYPE.Alarm_UnitVoltage_Type:
				let unitVoltStatus = 'Unit Voltage Alarm: ';
				if (number === ALARM_SEVERITY_CODE.CRITICAL) {
					unitVoltStatus = 'Critical Alarm:';
				} else if (number === ALARM_SEVERITY_CODE.MAINTENANCE) {
					unitVoltStatus = 'Maint Alert:';
				}

				unitVoltStatus += ' String ' + stringNum + ' Unit ' + unitNum + ' Voltage: ';
				unitVoltStatus += dataFlagsToText(value, event.get_data_flags, ' VDC');

				return unitVoltStatus;
				
			case ALARM_TYPE.Alarm_AvgImpedance_Type:
				let unitAvgImpedStatus = 'Average Impedance Alarm: ';
				if (number === ALARM_SEVERITY_CODE.CRITICAL) {
					unitAvgImpedStatus = 'Critical Alarm:';
				} else if (number === ALARM_SEVERITY_CODE.MAINTENANCE) {
					unitAvgImpedStatus = 'Maint Alert:';
				}
				
				unitAvgImpedStatus += ' String ' + stringNum + ' Unit ' + unitNum + ' Impedance: ';
				unitAvgImpedStatus += dataFlagsToText(value, event.get_data_flags, ' mΩ (Avg Method)');
				
				return unitAvgImpedStatus;
				
			case ALARM_TYPE.Alarm_InitImpedance_Type:
				let unitInitImpedStatus = 'Initial Impedance Alarm: ';
				if (number === ALARM_SEVERITY_CODE.CRITICAL) {
					unitInitImpedStatus = 'Critical Alarm:';
				} else if (number === ALARM_SEVERITY_CODE.MAINTENANCE) {
					unitInitImpedStatus = 'Maint Alert:';
				}

				unitInitImpedStatus += ' String ' + stringNum + ' Unit ' + unitNum + ' Impedance: ';
				unitInitImpedStatus += dataFlagsToText(value, event.get_data_flags, ' mΩ (Initial Method)');
				
				return unitInitImpedStatus;
				
			case ALARM_TYPE.Alarm_Temperature_Type:
				let tempAlarmStatus = '';
				if (number === ALARM_TEMP_CODE.AMBIENT) {
					tempAlarmStatus = 'Ambient Temp Alarm: ';
				} else if (number === ALARM_TEMP_CODE.UNIT) {
					tempAlarmStatus = 'String ' + stringNum + ' Unit ' + unitNum + ' Temp Alarm: ';
				} else {
					tempAlarmStatus = 'Battery Temp ' + (number - 1) + ' Alarm: ';
				}

				let tempAlarmValue = measUnitsConversion(value).toFixed(1);
				tempAlarmStatus += dataFlagsToText(tempAlarmValue, event.get_data_flags, tempUnits);
				
				return tempAlarmStatus;
				
			case ALARM_TYPE.Alarm_DiffTemperature_Type:
				let tempDiffAlarmStatus = '';
				if (number === ALARM_TEMP_CODE.UNIT) {
					tempDiffAlarmStatus = 'String ' + stringNum + ' Unit ' + unitNum + ' Temp Alarm: ';
				} else {
					tempDiffAlarmStatus = 'Battery Temp ' + (number - 1) + ' Alarm: ';
				}

				let diffTempAlarmValue = measUnitsConversion(value, true).toFixed(1);
				tempDiffAlarmStatus += dataFlagsToText(diffTempAlarmValue, event.get_data_flags, tempUnits);
				tempDiffAlarmStatus += ' above ambient'
				
				return tempDiffAlarmStatus;
				
			case ALARM_TYPE.Alarm_Nicad_Type:
				return 'Standby battery out of limits';
				
			case ALARM_TYPE.Alarm_Unlearned_Type:
				return 'BVS is unlearned';
				
			case ALARM_TYPE.Alarm_WasUnlearned_Type:
				return 'BVS is unable to learn';
				
			case ALARM_TYPE.Alarm_GroundFault_Type:
				return 'Ground Fault';
				
			case ALARM_TYPE.Alarm_FuseOut_Type:
				return 'BVS is unable to learn';
				
			case ALARM_TYPE.Alarm_Aux1_Type:
				return 'Auxiliary Event';
				
			case ALARM_TYPE.Alarm_MemBattery_Type:
				return 'Memory battery out of limits';
				
			case ALARM_TYPE.Alarm_WrongNbrUnits_Type:
				return 'BVS found the wrong number of units';
				
			case ALARM_TYPE.Alarm_WrongCntrLead_Type:
				return 'BVS found the center lead placed incorrectly';
				
			case ALARM_TYPE.Alarm_NoImpMsr_Type:
				return 'BVS was unable to take impedance measurements';
				
			case ALARM_TYPE.Alarm_StringVoltage_Type:
				let stringVoltStatus = 'String ' + stringNum + ' Voltage Alarm: ';
				stringVoltStatus += dataFlagsToText(value, event.get_data_flags, ' VDC');

				return stringVoltStatus;
				
			case ALARM_TYPE.Alarm_LVIRA_Aux1_Type:
				return 'Auxiliary Event 1';
				
			case ALARM_TYPE.Alarm_LVIRA_Aux2_Type:
				return 'Auxiliary Event 2';
				
			case ALARM_TYPE.Alarm_LVIRA_Aux3_Type:
				return 'Auxiliary Event 3';
				
			case ALARM_TYPE.Alarm_LVIRA_Aux4_Type:
				return 'Auxiliary Event 4';
				
			case ALARM_TYPE.Alarm_WrongNbrVoltModules_Type:
				return 'Wrong number of voltage modules found';
				
			case ALARM_TYPE.Alarm_WrongNbrCurrentModules_Type:
				return 'Wrong number of current modules found';
				
			case ALARM_TYPE.Alarm_CommErrorVoltModule_Type:
				return 'Communication error with voltage module';
				
			case ALARM_TYPE.Alarm_CommErrorCurrentModule_Type:
				return 'Communication error with current module';
				
			case ALARM_TYPE.Alarm_UnknownModuleType_Type:
				return 'Found unknown type of module';
				
			case ALARM_TYPE.Alarm_CorruptConfig_Type:
				if (number === 1) {
					return 'Corrupted configuration due to bad checksum';
				} else if (number === 2) {
					return 'Corrupted configuration due to value out of limits';
				}
				return 'Unknown Corrupt Configuration Alarm';
				
			case ALARM_TYPE.Alarm_HardwareFailure_Type:
				if (number === 1) {
					return 'Hardware failure of network / local serial port';
				} else if (number === 2) {
					return 'Hardware failure of modem serial port';
				} else if (number === 3) {
					return 'Hardware failure of module serial port';
				}
				return 'Unknown Hardware Failure Alarm';
				
			case ALARM_TYPE.Alarm_BackupBattery_Type:
				return 'Backup battery out of limits: ' + value.toFixed(1) + ' VDC';
				
			case ALARM_TYPE.Alarm_ModuleInitFailure_Type:
				return 'Module failed to initialize at position: ' + number;
				
			case ALARM_TYPE.Alarm_ImpMsrmentAbortHighPosVolt_Type:
				return 'Measurement aborted due to high voltage on pos. half string';
				
			case ALARM_TYPE.Alarm_ImpMsrmentAbortLowPosVolt_Type:
				return 'Measurement aborted due to low voltage on pos. half string';
				
			case ALARM_TYPE.Alarm_ImpMsrmentAbortHighNegVolt_Type:
				return 'Measurement aborted due to high voltage on neg. half string';
				
			case ALARM_TYPE.Alarm_ImpMsrmentAbortLowNegVolt_Type:
				return 'Measurement aborted due to low voltage on neg. half string';
				
			case ALARM_TYPE.Alarm_ImpMsrmentAbortHighLoadTemp_Type:
				return 'Measurement aborted due to high load plate temperature';
				
			case ALARM_TYPE.Alarm_ImpMsrmentAbortDischarge_Type:
				return 'Measurement aborted due to a discharge';
				
			case ALARM_TYPE.Alarm_ModemFailure_Type:
				return 'Modem Failure';
				
			case ALARM_TYPE.Alarm_ModemLineFailure_Type:
				return 'Modem Line Error';
				
			case ALARM_TYPE.Alarm_InvalidCommConfig_Type:
				return 'Invalid communications configuration';
				
			case ALARM_TYPE.Alarm_NetworkMissing_Type:
				return 'Network controller is missing';
				
			case ALARM_TYPE.Alarm_WrongNbrVoltagesVM24T_Type:
				return 'Wrong number of voltages (' + Number(value) + ') found on module ' + number;
				
			case ALARM_TYPE.Alarm_WrongNbrTempsVM24T_Type:
				return 'Wrong number of temperatures (' + Number(value) + ') found on module ' + number;
				
			case ALARM_TYPE.Alarm_TemperatureVM24T_Type:
				let VM24TempValue = measUnitsConversion(value).toFixed(1);
				return 'Temperature Sensor ' + number + ': ' + dataFlagsToText(VM24TempValue, event.get_data_flags, tempUnits);
				
			case ALARM_TYPE.Alarm_TemperatureVM24TDifferential_Type:
				let VM24DiffTempValue = measUnitsConversion(value, true).toFixed(1);
				return 'Temperature Sensor ' + number + ': ' + dataFlagsToText(VM24DiffTempValue, event.get_data_flags, tempUnits) + ' above ambient';
				
			case ALARM_TYPE.Alarm_ModuleRelearnConnectionFailure_Type:
				return 'Module ' + number + ' failed to relearn its connections';
				
			case ALARM_TYPE.Alarm_StringBreakerOpen_Type:
				return 'String ' + stringNum + ' breaker is open';
				
			case ALARM_TYPE.Alarm_ImpMsrmentAbortStringBreakerOpen_Type:
				return 'Measurement aborted due to string ' + stringNum + ' breaker being open';
				
			case ALARM_TYPE.Alarm_LControllerHardwareFailure_Type:
				switch(number) {
					case 1:
						return 'Ambient Sensor Fault - Equipment Hardware Alarm';
					case 2:
						return 'S-Module Communications Fault - Equipment Hardware Alarm';
					case 3:
						return 'I-Module Communications Fault - Equipment Hardware Alarm';
					case 4:
						return 'Controller needs reboot';
					case 5:
						return 'S-Module Communication Fault during Measurement';
					case 6:
						return 'I-Module Communication Fault during Measurement';
					case 7:
						return 'S-Module Not Ready';
					default:
						return 'Unknown Equipment Hardware Alarm';
				}
				
			case ALARM_TYPE.Alarm_LControllerConfigurationAlarm_Type:
				switch(number) {
					case 1:
						return 'Redundant S-Module Address - Equipment Configuration Alarm';
					case 2:
						return 'Redundant I-Module Address - Equipment Configuration Alarm';
					case 3:
						return 'Redundant S-Module BVM Address - Equipment Configuration Alarm';
					case 4:
						return 'Redundant I-Module BVM Address - Equipment Configuration Alarm';
					case 5:
						return 'Location Quantity out of Range - Equipment Configuration Alarm';
					case 6:
						return 'Module / BVM Quantity Mismatch - Equipment Configuration Alarm';
					case 7:
						return 'S-Module Quantity out of Range - Equipment Configuration Alarm';
					case 8:
						return 'I-Module Quantity out of Range - Equipment Configuration Alarm';
					case 9:
						return 'S-Module Address out of Range - Equipment Configuration Alarm';
					case 10:
						return 'I-Module Address out of Range - Equipment Configuration Alarm';
					case 11:
						return 'S-Module BVM 0 String or Unit - Equipment Configuration Alarm';
					case 12:
						return 'I-Module BVM 0 String - Equipment Configuration Alarm';
					case 13:
						return 'I-Module Communications Fault - Equipment Hardware Alarm';
					default:
						return 'Unknown Equipment Configuration Alarm';
				}
				
			case ALARM_TYPE.Alarm_ImpMsrmentAbortManually_Type:
				return 'Measurement has been aborted manually';
				
			case ALARM_TYPE.Alarm_ImpMsrmentAbortMajorEquipmentAlarm_Type:
				return 'Measurement has been aborted due to a major equipment alarm';
				
			case ALARM_TYPE.Alarm_Wrong_Nbr_TSV_Modules:
				return 'Wrong number of TSV modules found: ' + number;
				
			case ALARM_TYPE.Alarm_Controller_Lost_External_Power:
				return 'The controller lost external power';
				
			case ALARM_TYPE.Alarm_LVIRA_Aux5:
				return 'Auxiliary Event 5';
				
			case ALARM_TYPE.Alarm_LVIRA_Aux6:
				return 'Auxiliary Event 6';
				
			case ALARM_TYPE.Alarm_LVIRA_Aux7:
				return 'Auxiliary Event 7';
				
			case ALARM_TYPE.Alarm_LVIRA_Aux8:
				return 'Auxiliary Event 8';
				
			case ALARM_TYPE.Alarm_CellQ_Modbus_Master_Comm_Error:
				return 'A Modbus Master error has occurred. Error Code: ' + number;
				
			case ALARM_TYPE.Alarm_CellQ_Modbus_Slave_Equipment_Error:
				return 'The controller has encountered an error on the Modbus Slave. Error Code: ' + number;
				
			case ALARM_TYPE.Alarm_Interconnect_Impedance_Type:
				if (number === ALARM_SEVERITY_CODE.CRITICAL || 
					number === ALARM_SEVERITY_CODE.MAINTENANCE) {
	
					let interconnectImpedStatus = 'Critical Alarm: String ' + stringNum + ' Unit ' + unitNum + ' Interconnect Impedance: ';
					interconnectImpedStatus += dataFlagsToText(value, event.get_data_flags, ' mΩ (Initial Method)');
					
					return interconnectImpedStatus;
				}
				return 'Unknown Interconnect Impedance Alarm';
				
			case ALARM_TYPE.Alarm_NetworkPingError_Type:
				return 'A network communication error has occurred between the computer and the BVS';
				
			case ALARM_TYPE.Alarm_DischargeMemoryFull_Type:
				return 'The discharge / charge memory is full. Please retrieve the data and clear the memory';
				
			case ALARM_TYPE.Alarm_PollFailure_Type:
				return 'Observer Poll Status: ' + PollFailureToStatusText(number);

			default:
				return 'Unknown Alarm Type';
		}
	}

	return '';
}

function PollFailureToStatusText(alarmNumber) {
	if (alarmNumber && alarmNumber > 0) {
		switch(alarmNumber) {
			case POLL_STATUS.STATUS_COM_PORT_NON_EXISTENT:
				return 'Unable to open comm port - comm port is not present';
				
			case POLL_STATUS.STATUS_COM_PORT_CANNOT_OPEN:
				return 'Unable to open comm port - comm port is busy';
				
			case POLL_STATUS.STATUS_UNABLE_TO_LOAD_LOC:
				return 'Unable to load BVM data';
				
			case POLL_STATUS.STATUS_UNABLE_TO_LOAD_COMM_SETTINGS:
				return 'Unable to load communication settings';
				
			case POLL_STATUS.STATUS_WRONG_COMM_PORT:
				return 'Comm port is wrong';
				
			case POLL_STATUS.STATUS_UNABLE_TO_CHANGE_COMM_SPEED:
				return 'Unable to change the comm speed';
				
			case POLL_STATUS.STATUS_COMMUNICATION_FAILURE:
				return 'Communications failure occurred No Response';
				
			case POLL_STATUS.STATUS_LOCATION_ID_WRONG:
				return 'Location IDs did not match';
				
			case POLL_STATUS.STATUS_CONTROLLER_ID_WRONG:
				return 'Wrong Controller';
				
			case POLL_STATUS.STATUS_NBR_STRINGS_WRONG:
				return 'Number of strings did not match';
				
			case POLL_STATUS.STATUS_NBR_UNITS_WRONG:
				return 'Number of units did not match';
				
			case POLL_STATUS.STATUS_BUSY_MEASURING_IMP:
				return 'The BVS is busy measuring impedance';
				
			case POLL_STATUS.STATUS_BUSY_IN_DISCHARGE:
				return 'The BVS is busy taking discharge / charge measurements';
				
			case POLL_STATUS.STATUS_ERROR_RETRIEVING_DISCHARGE_DATA:
				return 'Error retrieving discharge / charge measurements';
				
			case POLL_STATUS.STATUS_NO_RESPONSE_FROM_MODEM:
				return 'No response from modem';
				
			case POLL_STATUS.STATUS_NUMBER_BUSY:
				return 'Number busy';
				
			case POLL_STATUS.STATUS_MODEM_ERROR:
				return 'Modem Error';
				
			case POLL_STATUS.STATUS_NO_DIALTONE:
				return 'No Dialtone';
				
			case POLL_STATUS.STATUS_DIAL_TIMEOUT:
				return 'Dial timed out';
				
			case POLL_STATUS.STATUS_ERROR_RETRIEVING_MSR_DATA:
				return 'Error retrieving measurement data';
				
			case POLL_STATUS.STATUS_NEEDS_PHONE_NUMBER:
				return 'Phone number is missing';
				
			case POLL_STATUS.STATUS_NEEDS_NO_PHONE_NUMBER:
				return 'Dial modem not available on comm port';
				
			case POLL_STATUS.STATUS_NETWORK_CONNECTION_TIMEOUT:
				return 'Network connection timeout';
				
			case POLL_STATUS.STATUS_NO_ANSWER:
				return 'No Answer';
				
			case POLL_STATUS.STATUS_NO_CARRIER:
				return 'No Carrier';
				
			case POLL_STATUS.STATUS_DELAY_RETRIEVING_DISCHARGE_DATA:
				return 'Discharge data must first be retrieved by the master controller';
				
			case POLL_STATUS.STATUS_DELAY_RETRIEVING_MSR_DATA:
				return 'Measurement data must first be retrieved from the master controller';
				
			case POLL_STATUS.STATUS_MODEL_NBR_WRONG:
				return 'Model number does not match';
				
			case POLL_STATUS.STATUS_NBR_TEMPS_WRONG:
				return 'The number of temperature sensors did not match';
				
			case POLL_STATUS.STATUS_SERIAL_NBR_WRONG:
				return 'The serial numbers did not match';
				
			case POLL_STATUS.STATUS_LOCATION_ID_DOESNT_EXIST:
				return 'The Location ID is not available in the battery monitor';
				
			case POLL_STATUS.STATUS_MODEL_NOT_PERMITTED:
				return 'Communication with this model battery monitor is not permitted';
		
			case POLL_STATUS.STATUS_SUCCESS_POLL:
				return 'Poll Successful';
				
			case POLL_STATUS.STATUS_SUCCESS_DISCHARGE_ALARM:
				return 'Received a discharge / charge notification';
				
			case POLL_STATUS.STATUS_SUCCESS_RCVD_ALARM:
				return 'Received one or more BVS event(s)';
		
			case 10013:
				return 'Permisson Denied';
				
			case 10048:
				return 'The address is already in use';
				
			case 10049:
				return 'The address is not available';
				
			case 10047:
				return 'Address family not supported by protocol family';
				
			case 10037:
				return 'Operation already in progress';
				
			case 10053:
				return 'Network connection has aborted';
				
			case 10061:
				return 'Connection refused';
				
			case 10054:
				return 'Network connection has reset';
				
			case 10039:
				return 'Destination address required';
				
			case 10014:
				return 'Bad address';
				
			case 10065:
				return 'No route to host';
				
			case 10036:
				return 'Operation now in progress';
				
			case 10004:
				return 'Interrupted funtion call';
				
			case 10022:
				return 'Invalid argument';
				
			case 10056:
				return 'Socket is already connected';
				
			case 10024:
				return 'Too many open sockets';
				
			case 10040:
				return 'Message too long';
				
			case 10050:
				return 'Network is down';
				
			case 10052:
				return 'Network connection was reset';
				
			case 10051:
				return 'The network cannot be reached from this host at this time';
				
			case 10055:
				return 'No buffer space available';
				
			case 10042:
				return 'Socket is not connected';
				
			case 10057:
				return 'Network connection has closed';
				
			case 10038:
				return 'Socket operation on non-socket';
				
			case 10045:
				return 'Protocol family not supported';
				
			case 10067:
				return 'Too many processes';
				
			case 10043:
				return 'Protocol not supported';
				
			case 10041:
				return 'Protocol wrong type for socket';
				
			case 10058:
				return 'Network connection has shutdown';
				
			case 10044:
				return 'Socket type not supported';
				
			case 10060:
				return 'Attempt to connect timed out without establishing a connection';
				
			case 11001:
				return 'Host not found';
				
			case 10093:
				return 'Network initialization not successful';
				
			case 11003:
				return 'This is non-recoverable error';
				
			case 10091:
				return 'Network subsystem is unavailable';
		
			default:
				return 'Unknown Error';
		}
	}

	return 'Unknown Error';
}